import { useMediaQuery } from 'react-responsive'

export const useMediaQueryHelper = () => {
  const isDesktop = useMediaQuery({
    // ref: https://tailwindcss.com/docs/responsive-design we use md as desktop (includes tablets)
    query: '(min-width:768px)',
  })

  return {
    isDesktop,
  }
}
